if (jQuery('.all-work').length) {

    (function () {

        const loader = document.querySelector('.pagination-loader')

        let container = jQuery('.all-work'),
            isLoading = false,
            page = parseInt(container.data('page')),
            limit = parseInt(container.data('total-pages')),
            url = container.data('pagination-url'),
            service = '',
            industry = ''


        function isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)

            );
        }


        const FetchPosts = (replaceCards) => {
            /**
             * remove return to enable pagination
             */

            if (isLoading || page === limit) {
                return
            }
            isLoading = true;

            jQuery('.pagination-loader >div').fadeIn('fast')
            jQuery( document ).trigger( "parallaxPause");

            page++


            $.ajax({
                method: 'GET',
                url: url.replace('{PAGE}', page) + `?service=${service}&industry=${industry}`,
                headers: {
                    accept: 'application/json'
                },
                success(data) {
                    if (data.success) {

                        if (typeof replaceCards !== 'undefined') {
                            container.html(data.data.cards)
                        } else {
                            container.append(data.data.cards)
                        }

                        limit = data.data.totalPages

                        jQuery('.work-card.hidden').removeClass('hidden').fadeIn('slow')
                        isLoading = false;


                        if (limit && page !== limit && isInViewport(loader)) {
                            FetchPosts()
                        }
                        if (!data.data.totalPages) {
                            container.append('<h3>No results found</h3>')
                        }
                    }
                    jQuery('.pagination-loader >div').fadeOut('fast')
                    jQuery( document ).trigger( "parallaxResume");
                },
                error() {
                    jQuery('.pagination-loader >div').fadeIn('fast')
                    jQuery( document ).trigger( "parallaxResume");
                }
            })

        }


        if (limit && page !== limit && !isLoading && isInViewport(loader)) {
            FetchPosts()
        }

        document.addEventListener('scroll', function () {
            if (limit && page !== limit && !isLoading && isInViewport(loader)) {
                FetchPosts()
            }

        }, {
            passive: true
        });


        const changeFilter = (button) => {

            page = 0
            limit = 1
            isLoading = false

            let slug = button.data('slug'),
            type = button.data('type')


            if (type === 'service') {
                service = slug
            } else if (type === 'industry') {
                industry = slug
            }

            container.html('')
            FetchPosts(true)
        }


        jQuery(document).on('click', '.all-work-list .dropdown-title', function () {
            let button = jQuery(this),
                dropdown = button.parent(),
                list = dropdown.find('.dropdown-list')




            if (dropdown.hasClass('open')) {

                list.slideUp('fast')
                dropdown.removeClass('open')
            } else {
                jQuery('.dropdown.open').removeClass('open').find('.dropdown-list').slideUp('fast')
                list.slideDown('fast')
                dropdown.addClass('open')
            }

        })

        jQuery(document).click(function (event) {
            let target = jQuery(event.target);
            if (!target.parents('.dropdown').length) {
                console.log(target.data())
                jQuery('.dropdown .dropdown-list').slideUp('fast')
                jQuery('.dropdown').removeClass('open')
            }
        });


        jQuery(document).on('click', '.all-work-list .dropdown .clear-selection', function (event) {

            event.preventDefault()


            let button = jQuery(this),
                parent = button.parent()


            parent.text(parent.data('type')).removeClass('filtered')

            changeFilter(parent)

            return false
        })
        jQuery(document).on('click', '.all-work-list .dropdown-list>div', function () {
            let button = jQuery(this),
                dropdown = button.parents('.dropdown'),
                list = button.parent(),
                title = button.text()


            dropdown
                .find('.dropdown-title')
                .text(title)
                .addClass('filtered')
                .append('<div class="clear-selection" ><div><span></span><span></span></div></div>')


            if (dropdown.hasClass('open')) {
                list.slideUp('fast')
                dropdown.removeClass('open')
            } else {
                list.slideDown('fast')
                dropdown.addClass('open')
            }

            changeFilter(button)

        })


    })();


}
